<template>
    <div class="title-block" :class="position + ' ' + customClass">
        <div class="title" v-html="headline" />
        <div class="divider" />
        <slot name="text" class="text">

        </slot>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .title-block {

        &.left {
            text-align: left;

            p {
                max-width: $maxwidth;
            }
        }

        &.center {
            text-align: center;

            p {
                padding: 0 calc(50% - (#{$maxwidth} / 2));
            }
        }

        &.right {
            text-align: right;

            p {
                padding-left: calc(100% - #{$maxwidth});
            }
        }

        &.mb-xl {
            margin-bottom: $margin--xl;
        }

        .title {
            font-size: $fontsize--xl;
            font-family: $fontfamily--main;
            font-weight: $fontweight--main;
            color: $color--dark;
            line-height: 1.4;
        }

        .divider {
            display: inline-block;
            height: 1px;
            width: 50px;
            background: $color--dark;
            display: none;
        }

        p {
            font-family: $fontfamily--secondary;
            color: $color--dark;
            font-weight: $fontweight--light;
            font-size: $fontsize--main;
            line-height: $fontsize--main * 1.5;
            margin-top: 0;

            a {
                text-decoration: none;
                color: $color--main;
                font-weight: $fontweight--main;
            }
        }
    }

</style>

<script>
export default {
    props: ['headline', 'position', 'customClass']
}
</script>



// WEBPACK FOOTER //
// title.vue?30a75e00